import React, { useState } from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { DateTime } from 'luxon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function WeekFilter({goForwardMonth,goBackMonth, goBackWeek, dateStart, lastWeek, dateEnd, goForwardWeek}) {
    const [openBox, setOpenBox] = useState(false)
    return (
        <div className="week_filter">
            <div className={`week_filter-openBox ${openBox}`}>
                <div className="week_filter-openBox_close" onClick={() => setOpenBox(false)}>
                    <KeyboardArrowDownIcon />
                </div>
                <div className="dayBox">
                    <div className="iconBox">
                        <ArrowBackIosIcon onClick={() => goBackWeek()} />
                    </div>
                    <p className='main'>{DateTime.fromISO(dateStart).toFormat('dd')} - {DateTime.fromISO(dateEnd).toFormat('dd')}</p>
                    <div className="iconBox">
                        <ArrowForwardIosIcon onClick={() => dateEnd === lastWeek ? null : goForwardWeek()} />
                    </div>
                </div>
                <div className="dayBox">
                    <div className="iconBox">
                        <ArrowBackIosIcon onClick={() => goBackMonth()} />
                    </div>
                    <p className='main'>{DateTime.fromISO(dateStart).toFormat('MMMM')}</p>
                    <div className="iconBox">
                        <ArrowForwardIosIcon  onClick={() => dateEnd === lastWeek ? null : goForwardMonth()} />
                    </div>
                </div>
            </div>
            <div className="week_filter-dateChanger" onClick={() => setOpenBox(true)}>
                <p className='dayName'>{DateTime.fromISO(dateStart).toFormat('EEE')}</p>
                <p className='dayNumber'>{DateTime.fromISO(dateStart).toFormat('dd')}</p>
                <ArrowForwardIosIcon />
                <p className='dayName'>{DateTime.fromISO(dateEnd).toFormat('EEE')}</p>
                <p className='dayNumber'>{DateTime.fromISO(dateEnd).toFormat('dd')}</p>
                <KeyboardArrowDownIcon className='open'/>
            </div>
            <div className="week_filter-switch">
            </div>
        </div>
    )
}

export default WeekFilter